import React from 'react';
import PropTypes from 'prop-types';
import {Box, Typography, Button} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {BLACK_100} from '../../theme';

const InlineError = ({message, onRetry, retryLabel = 'Retry', compact}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: compact ? 'row' : 'column',
        alignItems: compact ? 'center' : 'flex-start',
        gap: '0.75rem',
        padding: '0.75rem',
        border: '1px solid #FFC738',
        borderRadius: '0.5rem',
        bgcolor: '#FFEEC3',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          flex: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            bgcolor: '#FFC738',
            height: '1.25rem',
            minWidth: '1.25rem',
            borderRadius: '50%',
          }}
        >
          <ErrorOutlineIcon sx={{height: '1rem', width: '1rem'}} />
        </Box>
        <Typography
          sx={{
            color: BLACK_100,
            fontSize: '0.875rem',
            fontWeight: 400,
            lineHeight: '1.125rem',
            textAlign: 'left',
          }}
        >
          {message}
        </Typography>
      </Box>
      {onRetry && (
        <Button
          size="small"
          onClick={onRetry}
          sx={{
            textTransform: 'none',
            color: BLACK_100,
            minWidth: 'auto',
            p: '2px 8px',
            fontSize: '0.75rem',
            fontWeight: 500,
            border: '1px solid #FFC738',
            borderRadius: '0.25rem',
            '&:hover': {
              backgroundColor: 'rgba(255, 199, 56, 0.3)',
            },
          }}
        >
          {retryLabel}
        </Button>
      )}
    </Box>
  );
};

InlineError.propTypes = {
  message: PropTypes.string.isRequired,
  onRetry: PropTypes.func,
  retryLabel: PropTypes.string,
  compact: PropTypes.bool,
};

export default InlineError;
